function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonYoutube = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ButtonYoutubeWrap, _extends({}, props, {
    iconLeft: /*#__PURE__*/React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 32 22"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Logo/Third-Party/YouTube/Reversed",
      transform: "translate(0.000000, -5.000000)",
      fill: "#FFFFFE"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M31.3312727,8.43537097 C32,10.8862419 32,16 32,16 C32,16 32,21.1135806 31.3312727,23.5648065 C30.9632727,24.9169194 29.8790909,25.9817903 28.5021818,26.343371 C26.0067273,27 16,27 16,27 C16,27 5.99327273,27 3.49781818,26.343371 C2.12109091,25.9817903 1.03672727,24.9169194 0.668727273,23.5648065 C0,21.1135806 0,16 0,16 C0,16 0,10.8862419 0.668727273,8.43537097 C1.03672727,7.08308065 2.12109091,6.01820968 3.49781818,5.65680645 C5.99327273,5 16,5 16,5 C16,5 26.0067273,5 28.5021818,5.65680645 C29.8790909,6.01820968 30.9632727,7.08308065 31.3312727,8.43537097 Z M12.7272727,20.6428871 L21.0909091,16.0001774 L12.7272727,11.3571129 L12.7272727,20.6428871 Z",
      id: "Combined-Shape"
    }))))
  }), children);
};
export const ButtonYoutubeWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.youtube};
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.youtube};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;